/* eslint-disable react/jsx-pascal-case */
import {
  create,
  isPlayerSupported,
  LogLevel,
  PlayerEventType,
  PlayerState,
} from "amazon-ivs-player";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Live_End_Modal from "../Modal/Live_End_Modal";
import Loader from "../../../../Component/Loader";
import { Icon } from "../../../../Component/style/common_style";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";
import { live_info_type } from "../../../User/Live/Live";

interface LiveComponentProps {
  volume: number;
  manage?: boolean;
  set_All_Visible?: (visible: boolean) => void;
  all_visible?: boolean;
  live_info: live_info_type;
}

const Live_Component: React.FC<LiveComponentProps> = ({
  volume,
  manage,
  set_All_Visible,
  all_visible,
  live_info,
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const playerRef = useRef<any>(null);
  const [isLoading, set_IsLoading] = useState<boolean>(true);

  const [live_end_modal, set_Live_End_Modal] = useState(false);
  const open_Live_End = () => set_Live_End_Modal(!live_end_modal);

  useEffect(() => {
    if (!isPlayerSupported) {
      console.warn("현재 브라우저는 IVS 플레이어를 지원하지 않습니다.");
      return;
    }

    const player = create({
      wasmWorker:
        "https://player.live-video.net/1.40.0/amazon-ivs-worker.min.js",
      wasmBinary:
        "https://player.live-video.net/1.40.0/amazon-ivs-wasmworker.min.wasm",
    });

    player.setLogLevel(LogLevel.ERROR);
    playerRef.current = player;

    if (videoRef.current) {
      player.attachHTMLVideoElement(videoRef.current);
    }

    let bufferingTimer: NodeJS.Timeout | null = null;

    const getStreamInfo = async () => {
      try {
        const res = await api.post(url.Communication_url.getStreamInfo, {
          live_seq: live_info?.seq,
        });
        if (res.data.length === 0) {
          alert("방송서버와 연결되지 않았습니다. (키값이 없습니다)");
          return;
        }
        player.load(res.data.playUrl);
      } catch (err) {
        console.error("streaminfoErr", err);
      }
    };

    getStreamInfo();

    const retryInterval = 5000;
    const intervalId = setInterval(getStreamInfo, retryInterval);

    const onReady = () => {
      try {
        player.play();
      } catch (err) {
        console.warn("플레이어 재생 시도 중 오류 발생:", err);
      }
      if (bufferingTimer) {
        clearTimeout(bufferingTimer);
        bufferingTimer = null;
      }
    };

    const onPlaying = () => {
      set_IsLoading(false);
      clearInterval(intervalId);

      if (bufferingTimer) {
        clearTimeout(bufferingTimer);
        bufferingTimer = null;
      }
    };

    const onEnded = () => {
      // console.log("Player State - ENDED");

      !manage && open_Live_End();
    };

    const onBuffering = () => {
      // console.log("Player State - BUFFERING");
      set_IsLoading(true);

      if (bufferingTimer) {
        clearTimeout(bufferingTimer);
      }

      bufferingTimer = setTimeout(() => {
        if (player.getState() === PlayerState.BUFFERING) {
          !manage && open_Live_End();
          player.pause();
        }
      }, 15000); // 15초 이상 지속될 경우 종료로 간주
    };

    const onError = (err: any) => {
      if (err.code === 404) {
        console.log(
          "방송이 아직 시작되지 않았습니다. 5초 후에 다시 시도합니다."
        );
      }
    };

    player.addEventListener(PlayerState.READY, onReady);
    player.addEventListener(PlayerState.PLAYING, onPlaying);
    player.addEventListener(PlayerState.ENDED, onEnded);
    player.addEventListener(PlayerState.BUFFERING, onBuffering);
    player.addEventListener(PlayerEventType.ERROR, onError);

    player.setVolume(volume / 100);

    setTimeout(() => {
      set_Mute_Timer(false);
    }, 5000);

    return () => {
      clearInterval(intervalId);
      if (bufferingTimer) {
        clearTimeout(bufferingTimer);
      }
      player.removeEventListener(PlayerState.READY, onReady);
      player.removeEventListener(PlayerState.PLAYING, onPlaying);
      player.removeEventListener(PlayerState.ENDED, onEnded);
      player.removeEventListener(PlayerState.BUFFERING, onBuffering);
      player.removeEventListener(PlayerEventType.ERROR, onError);
      player.delete();
    };
  }, []);

  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.setVolume(volume / 100);
      playerRef.current.setMuted(false);
    }
  }, [volume]);

  const Mute_Off = () => {
    playerRef.current.setMuted(false);
    playerRef.current.setVolume(1);
  };

  const [mute_timer, set_Mute_Timer] = useState(true);

  // console.log(playerRef.current && playerRef.current.getState());
  // console.log(playerRef.current && playerRef.current.getVolume());
  // console.log(playerRef.current && playerRef.current.isPaused());
  // console.log(playerRef.current && playerRef.current.isMuted());

  return (
    <VideoContainer translate="no">
      {playerRef.current && !playerRef.current.isPaused() && isLoading ? (
        <Loader />
      ) : (
        <></>
      )}
      {playerRef.current && playerRef.current.isPaused() && (
        <Play_Btn
          onClick={() => {
            playerRef.current.play();
          }}
        >
          <Icon src={require("../../../../Image/ic_play_white.png")} />
        </Play_Btn>
      )}
      {playerRef.current &&
        !playerRef.current.isPaused() &&
        !isLoading &&
        playerRef.current.isMuted() &&
        mute_timer && (
          <Sound_Mute_Div onClick={Mute_Off}>
            <Sound_Mute src={require("../../../../Image/ic_sound.png")} />
          </Sound_Mute_Div>
        )}

      {playerRef.current &&
        !playerRef.current.isPaused() &&
        !isLoading &&
        playerRef.current.isMuted() &&
        !mute_timer && (
          <Sound_Mute_Div onClick={Mute_Off}>
            <Sound_Mute2 src={require("../../../../Image/ic_sound2.png")} />
          </Sound_Mute_Div>
        )}
      <video
        onClick={() => {
          playerRef.current &&
            !playerRef.current.isPaused() &&
            !playerRef.current.isMuted() &&
            set_All_Visible &&
            set_All_Visible(!all_visible);
        }}
        ref={videoRef}
        playsInline
      />
      <Live_End_Modal visible={live_end_modal} handleModal={open_Live_End} />
    </VideoContainer>
  );
};

export default Live_Component;

const VideoContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;

  video {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  video::-webkit-media-controls-timeline,
  video::-webkit-media-controls-current-time-display {
    display: none;
  }
`;

const Play_Btn = styled.div`
  /* cursor: pointer;
  width: 50px;
  height: 50px;
  position: absolute;
  left: 47%;
  top: 40%; */
  z-index: 50;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  cursor: pointer;
`;

const Sound_Mute_Div = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 45;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

const Sound_Mute = styled(Icon)`
  display: flex;
  margin-bottom: 100px;
  align-self: center;
  justify-self: center;
  cursor: pointer;
`;

const Sound_Mute2 = styled(Icon)`
  z-index: 45;
  position: absolute;
  display: flex;
  top: 10%;
  right: 30px;
  cursor: pointer;
`;
